/**
 * Persist portal auth across tab/browser restarts.
 * Reads localStorage first, falls back to sessionStorage (legacy).
 * Writes always go to localStorage and clear the sessionStorage copy.
 */

const AUTH_KEYS = [
  "ID_TOKEN",
  "USER_STATE",
  "ADMIN_TOKEN",
  "is_agent",
  "is_staff",
  "staff",
  "staff_id",
  "staff_permissions",
  "agent",
  "agent_id",
  "agent_permissions",
  "is_superAdmin",
  "BRANCHES_COUNT",
  "SELECTED_BRANCH",
  "MAIN_BRANCH",
  "subscription",
  "personalInfo",
  "impersonation_token",
  "is_impersonating",
  "ADMIN_USER_STATE",
  "enable_room_reservations",
  "packages_enabled",
];

export function authGet(key) {
  const localVal = localStorage.getItem(key);
  if (localVal !== null) return localVal;
  return sessionStorage.getItem(key);
}

export function authSet(key, value) {
  const str = value === undefined || value === null ? "" : String(value);
  localStorage.setItem(key, str);
  sessionStorage.removeItem(key);
}

export function authRemove(key) {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

/** Copy any legacy session auth into localStorage once on boot. */
export function migrateAuthStorage() {
  AUTH_KEYS.forEach((key) => {
    const sessionVal = sessionStorage.getItem(key);
    if (sessionVal !== null && localStorage.getItem(key) === null) {
      localStorage.setItem(key, sessionVal);
    }
    if (sessionVal !== null) {
      sessionStorage.removeItem(key);
    }
  });
}

/** Clear auth-related keys only (avoid wiping unrelated localStorage). */
export function clearAuthStorage() {
  AUTH_KEYS.forEach((key) => authRemove(key));
}

export default {
  get: authGet,
  set: authSet,
  remove: authRemove,
  migrate: migrateAuthStorage,
  clear: clearAuthStorage,
};
